import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

import i18n from "i18n-react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { DragCard, Toast } from "C4";

const DragDrop = ({
  answer,
  contentComplete,
  correctAnswerText,
  disableHeader,
  disableToast,
  error,
  options,
  question,
}) => {
  const correctOrder = answer.map((item, i) => ({
    answer: item,
    option: options[i],
  }));

  const shuffledOptions = options
    .filter((option) => option.length > 0)
    .map((option) => ({ option, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ option }, i) => ({ option, id: i }));

  const [draggedOptions, setDraggedOptions] = useState(shuffledOptions);
  const [toastContent, setToastContent] = useState(null);

  const moveListItem = useCallback(
    (dragIndex, hoverIndex) => {
      const dragItem = draggedOptions[dragIndex];
      const hoverItem = draggedOptions[hoverIndex];
      setDraggedOptions((items) => {
        const updatedOrder = [...items];
        updatedOrder[dragIndex] = hoverItem;
        updatedOrder[hoverIndex] = dragItem;
        return updatedOrder;
      });
    },
    [draggedOptions]
  );

  const checkAnswer = () => {
    if (
      draggedOptions.every((item, i) => item.option === correctOrder[i].option)
    ) {
      setToastContent({
        position: "bottom-center",
        content: correctAnswerText,
      });
      contentComplete();
    } else {
      error(true);
    }
  };

  return (
    <div className="container__question">
      {!disableHeader && <div className="container__question--image" />}
      <div className="container__question--content">
        <h4 className="container__title">{question}</h4>
        <div className="question__cards">
          <div className="question__cards--answers">
            {answer.map((item) => (
              <div key={item} className="card">
                {item}
              </div>
            ))}
          </div>
          <DndProvider backend={HTML5Backend}>
            <div className="question__cards--options">
              {draggedOptions.map((item, i) => (
                <DragCard
                  key={item.id}
                  index={i}
                  text={item.option}
                  moveListItem={moveListItem}
                />
              ))}
            </div>
          </DndProvider>
        </div>
        {!disableToast && (
          <Toast
            trigger={toastContent !== null}
            onOpen={() => {
              setToastContent(null);
            }}
            {...toastContent}
          />
        )}
        <button type="button" onClick={checkAnswer}>
          {i18n.translate("trainingScreens.confirm")}
        </button>
      </div>
      {error(false)}
    </div>
  );
};

export default DragDrop;

DragDrop.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string),
  correctAnswerText: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string),
  question: PropTypes.string.isRequired,
  error: PropTypes.func,
  contentComplete: PropTypes.func.isRequired,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
};

DragDrop.defaultProps = {
  answer: [],
  options: [],
  error: () => {},
  disableHeader: false,
  disableToast: false,
};
